import { c as _c } from "react/compiler-runtime";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import Image from "next/image";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
export default function UserPageHeaderPfp(t0) {
  const $ = _c(6);
  const {
    profile,
    defaultBanner1,
    defaultBanner2
  } = t0;
  if (profile.pfp) {
    let t1;
    if ($[0] !== profile.pfp) {
      t1 = getScaledImageUri(profile.pfp, ImageScale.W_200_H_200);
      $[0] = profile.pfp;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t1) {
      t2 = <Image unoptimized={true} src={t1} alt="Profile picture" width="176" height="176" className="tw-flex-shrink-0 tw-object-contain tw-max-h-28 sm:tw-max-h-44 tw-w-auto tw-h-auto tw-rounded-lg tw-ring-[3px] tw-ring-white/30 tw-bg-iron-800" />;
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  const t1 = `linear-gradient(45deg, ${defaultBanner1} 0%, ${defaultBanner2} 100%)`;
  let t2;
  if ($[4] !== t1) {
    t2 = <div className="tw-flex-shrink-0 tw-h-36 sm:tw-h-44 tw-w-36 sm:tw-w-44 tw-rounded-lg tw-ring-[3px] tw-ring-white/30" style={{
      background: t1
    }} />;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}